
const pluralize = do(n) `{n} {n === 1 ? " reply" : " replies"}`

export tag Comment
	open = false
	prop comment
	<self>
		<div.by>
			<a route-to=`/user/{comment.user}`> "{comment.user} "
			"{comment.time_ago} ago"
		<div.text innerHTML=comment.content />
		if comment.comments.length
			<div.toggle .open=open >
				<a @click=(open = !open)> `{open ? "[-]" : "[+] " + pluralize(comment.comments.length) + " collapsed"}`
		if open
			<ul.comment-children>
				for comment in comment.comments
					<li>
						<Comment comment=comment />